import {Component} from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css";
import React from "react";
import Badge from 'react-bootstrap/lib/Badge';
import request from 'request-promise-native';
import LoadingModal from "../modals/LoadingModal";
import ValidatedFormComponent from "../ValidatedFormComponent";
import Col from 'react-bootstrap/lib/Col';
import Button from 'react-bootstrap/lib/Button';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Tooltip from 'react-bootstrap/lib/Tooltip';
import YesNoDialog from "../modals/YesNoDialog";
import SuccessDialog from "../modals/SuccessDialog";
import FailedDialog from "../modals/FailedDialog";
import FormDialog from "../modals/FormDialog";
import Alert from "react-bootstrap/lib/Alert";

const GET_ADMIN_LIST = "https://flexa-base.azurewebsites.net/api/GetAdminList";
const DELETE_ADMIN = "https://flexa-partner.azurewebsites.net/api/RemoveAdmin"; //TODO ADD
const ADD_ADMIN = "https://flexa-base.azurewebsites.net/api/CreateAdmin";

const MAIL_REGEX = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

function arraysEqual(a, b) {
    if (a === b) return true;
    if (a == null || b == null) return false;
    if (a.length != b.length) return false;

    for (let i = 0; i < a.length; ++i) {
        if (a[i] !== b[i]) return false;
    }
    return true;
}

class ListAdminsTab extends Component {

    constructor(props) {
        /*
            Props:
             - access_code
             - logout
        */
        super(props);

        this.state = {
            addAdminOpen: false,
            addingAdmin: false,
            addAdminSuccess: null,
            addAdminFailed: null,

            deleteAdminOpen: false,
            deleteAdmin: null,
            deletingAdmin: false,
            deleteAdminSuccess: null,
            deleteAdminFailed: null,

            admins: null,
            loading: true,

            searchButton: true,

            //Ordering
            currentOrderParam: null,
            currentOrderDesc: false,

            tableLoading: false,
            pages: 1,
            page: 0
        };

        this.pageCache = null;

        this.currentSearch = null;
    }

    async fetchData(state,instance) {
        console.log("State: ",state);
        console.log("Instance: ",instance);

        const sort = state.sorted[0];
        if(sort.desc!==this.state.currentOrderDesc || sort.id!==this.state.currentOrderParam) {
            this.pageCache = null;
            this.currentOrderDesc = sort.desc;
            this.setState({
                page: 0,
                currentOrderDesc: sort.desc,
                currentOrderParam: sort.id
            });
        }

        this.setState({
            tableLoading: true
        });

        if(this.pageCache==null) {
            const options = {
                method: 'POST',
                uri: GET_ADMIN_LIST,
                body: {
                    access_code: this.props.access_code,

                    orderDescending: sort.desc,
                    orderParam: sort.id,

                    search: this.currentSearch

                    //filterParam: this.state.currentSearch,
                    //filter: state.filter
                },
                json: true,
                resolveWithFullResponse: true,
                simple: false
            };

            const response = await request(options);

            if(response.statusCode!=200) {
                console.log('Logging out!');
                this.props.logout();
                return;
            }

            this.pageCache = [];
            this.pageCache[0] = response.body;

            if(response.body[0]==null || response.body[0].last) {
                this.setState({
                    admins: response.body,
                    tableLoading: false,
                    loading: false,
                    pages: 1
                });
            } else {
                this.setState({
                    admins: response.body,
                    tableLoading: false,
                    loading: false,
                    pages: 2
                });
            }

            console.log("Cards request success");
        } else {
            if(this.pageCache[state.page]!=null) {
                this.setState({
                    admins: this.pageCache[state.page],
                    tableLoading: false,
                    loading: false
                });
            } else {

                let lastSortedBy;

                if(this.pageCache[state.page-1]!=null) {
                    const page = this.pageCache[state.page-1];
                    console.log("Page: "+(state.page-1), page);
                    lastSortedBy = page[9][this.state.currentOrderParam];
                }
                console.log("Last sorted by '"+this.state.currentOrderParam+"': "+lastSortedBy);

                const options = {
                    method: 'POST',
                    uri: GET_ADMIN_LIST,
                    body: {
                        access_code: this.props.access_code,

                        lastSortedBy,

                        orderDescending: this.state.currentOrderDesc,
                        orderParam: this.state.currentOrderParam,

                        search: this.currentSearch

                        //filterParam: this.state.currentSearch,
                        //filter: state.filter
                    },
                    json: true,
                    resolveWithFullResponse: true,
                    simple: false
                };

                const response = await request(options);

                if(response.statusCode!=200) {
                    console.log('Logging out!');
                    this.props.logout();
                    return;
                }

                this.pageCache[state.page] = response.body;

                if(response.body[0]==null || response.body[0].last) {
                    this.setState({
                        admins: response.body,
                        tableLoading: false,
                        loading: false,
                        pages: state.page+1
                    });
                } else {
                    this.setState({
                        admins: response.body,
                        tableLoading: false,
                        loading: false,
                        pages: state.page+2
                    });
                }


                console.log("Cards request success");
            }
        }

    }

    //TODO add functionality
    async deleteAdmin(partner) {

        this.setState({
            deletingAdmin: true,
            deleteAdminSuccess: null,
            deleteAdminFailed: null
        });

        const options = {
            method: 'POST',
            uri: DELETE_ADMIN,
            body: {
                access_code: this.props.access_code,
                partner: partner.id
            },
            json: true,
            resolveWithFullResponse: true,
            simple: false
        };

        const response = await request(options);

        if(response.statusCode===200) {
            this.setState({
                deleteAdminSuccess: response.body,
                deletingAdmin: false,
            });
            this.resetTable();
            return;
        }

        if(response.statusCode===404) {
            this.props.logout();
        }

        this.setState({
            deleteAdminFailed: response.body,
            deletingAdmin: false,
        });

    }

    resetTable() {
        this.pageCache = null;
        this.setState({
            page: 0
        },() => {
            this.fetchData.bind(this)({
                sorted: [
                    {
                        desc: this.currentOrderDesc
                    }
                ]
            },null);
        });
    }

    async addAdmin(mail) {

        this.setState({
            addingAdmin: true,
            addAdminSuccess: null,
            addAdminFailed: null
        });

        const options = {
            method: 'POST',
            uri: ADD_ADMIN,
            body: {
                access_code: this.props.access_code,
                mail,
            },
            json: true,
            resolveWithFullResponse: true,
            simple: false
        };

        const response = await request(options);

        if(response.statusCode===200) {
            this.setState({
                addAdminSuccess: response.body,
                addingAdmin: false,
            });
            this.resetTable();
            return;
        }

        if(response.statusCode===404) {
            this.props.logout();
        }

        this.setState({
            addAdminFailed: response.body,
            addingAdmin: false,
        });

    }

    render() {
        if(!this.props.open) return null;
        return (
            <div className="page-wrapper">
                <div className="page-breadcrumb">
                    <div className="row">
                        <div className="col-12 d-flex no-block align-items-center">
                            <h3 className="page-title"><i className="mdi mdi-account"></i> Admins</h3>
                            <div className="ml-auto text-right">
                                <button className="btn btn-primary" onClick = {() => this.setState({addAdminOpen: true})}>
                                    <i className="mdi mdi-plus font-16"></i>Add Admin
                                </button>
                            </div>
                        </div>
                    </div>
                </div>


                <YesNoDialog open={this.state.deleteAdminOpen}
                             title="Delete partner"
                             text={(
                                <div>
                                    Do you really want to delete this partner?<br/>
                                    <b>Name:</b> {this.state.deleteAdmin ? this.state.deleteAdmin.name : ""}<br/>
                                    <b>E-Mail:</b> {this.state.deleteAdmin ? this.state.deleteAdmin.mail : ""}
                                </div>
                             )}
                             onYes={() => {
                                 this.deleteAdmin.bind(this)(this.state.deleteAdmin);
                                 this.setState({
                                     deleteAdminOpen: false,
                                     deleteAdmin: null,
                                     deletingAdmin: true
                                 });
                             }}
                             onNo={() => {
                                 this.setState({
                                     deleteAdminOpen: false,
                                     deleteAdmin: null,
                                 });
                             }}
                            />
                <LoadingModal open={this.state.deletingAdmin}
                                title="Deleting partner..."
                />

                <FailedDialog open={!!this.state.deleteAdminFailed}
                              onClose={() => this.setState({deleteAdminFailed:false})}
                              title="Delete failed"
                              text="Admin cannot be removed!"/>
                <SuccessDialog open={!!this.state.deleteAdminSuccess}
                               onClose={() => this.setState({deleteAdminSuccess:false})}
                               title="Delete success"
                               text="Admin has been deleted successfully!"/>

                <FormDialog open={this.state.addAdminOpen}
                            onClose={() => {
                                this.setState({
                                    addAdminOpen:false,
                                    addAdminFailed: null,
                                    addAdminSuccess: null
                                })
                            }}
                            titleText="Add admin"
                            submitText="Add admin"
                            inputs={[
                                {
                                    onValidate: (value) => {
                                        return MAIL_REGEX.test(value) ? null : "Not a valid e-mail!";
                                    },
                                    name: "E-Mail",
                                    type: "text",
                                    placeholder: "Enter admin's e-mail"
                                }
                            ]}
                            onSubmit={(obj) => {
                                const mail = obj["E-Mail"];
                                this.addAdmin.bind(this)(mail);
                            }}
                            notification={this.state.addAdminSuccess ? (<Alert bsStyle="success"><strong>{this.state.addAdminSuccess}</strong></Alert>) : this.state.addAdminFailed ? (<Alert bsStyle="danger"><strong>{this.state.addAdminFailed}</strong></Alert>) : ""}
                            loading={this.state.addingAdmin}/>

                <div className="mt-4">
                    <Col sm={4} xs={8}>
                        <ValidatedFormComponent
                            type="text"
                            placeholder="Search"
                            onValidate={input => {
                                return null;
                            }}
                            inputRef={ref => this.searchRef=ref}
                            onChange={input => {
                                if(input==='' && this.currentSearch!=null) {
                                    this.setState({
                                        searchButton: false
                                    });
                                    return;
                                }

                                if(input!==this.currentSearch) {
                                    if(!this.state.searchButton) this.setState({
                                        searchButton: true
                                    })
                                }
                                if(input===this.currentSearch) {
                                    if(this.state.searchButton) this.setState({
                                        searchButton: false
                                    });
                                }
                            }}
                        />
                    </Col>
                    {this.state.searchButton ? (<Button bsStyle="success" onClick={() => {
                        if(this.searchRef.value!=='') {
                            if(this.currentSearch === this.searchRef.value) return;
                            this.setState({
                                searchButton: false
                            });
                            this.currentSearch = this.searchRef.value;
                            this.resetTable();
                        }
                    }}>
                        <i className="fa fa-search"/>
                    </Button>) : (<Button bsStyle="danger" onClick={() => {
                        if(this.currentSearch) {
                            this.currentSearch = null;
                            this.setState({
                                searchButton: true
                            });
                            this.resetTable();
                        }
                    }}>
                        <i className="fa fa-window-close"/>
                    </Button>)}

                </div>
                <div className="container-fluid">
                    <ReactTable
                        loading={this.state.tableLoading}
                        defaultSorted={[
                            {
                                id: "name",
                                desc: false
                            }
                        ]}
                        data={this.state.admins==null ? [] : this.state.admins}
                        /*getTdProps={(state, rowInfo, column, instance) => {
                            if(rowInfo!=null && column.Header!=='Delete' && column.Header!=="") return {
                                style: {
                                    cursor: 'pointer'
                                },
                                onClick: e => {
                                    console.log("Cell - onClick", rowInfo.original);
                                    this.setState({
                                        addDeviceOpen: true,
                                        editDevice: rowInfo.original
                                    });
                                }
                            };
                            return {};
                        }}*/
                        columns={[
                            {
                                Header: "E-Mail",
                                accessor: "mail"
                            },
                            {
                                Header: "Username",
                                accessor: "username",
                                sortable: false
                            },
                            {
                                Header: "Claimed",
                                sortable: false,
                                filterable: false,
                                Cell: (row) => {
                                    if(row.original.ttl<0) {
                                        return (
                                            <Badge><i className="fa fa-check"/></Badge>
                                        );
                                    } else {
                                        let str = "";

                                        const seconds = row.original.remaining;

                                        let minutes = seconds/60;

                                        const hours = Math.floor(minutes/60);
                                        minutes = Math.floor(minutes%60);

                                        str+=hours+" hours";

                                        if(minutes!==0) {
                                            str+=" and "+minutes+" minutes";
                                        }

                                        str+=" remaining";

                                        return (
                                            <div>
                                                <Badge><i className="fa fa-times"/></Badge> <Badge>{str}</Badge>
                                            </div>
                                        );
                                    }
                                }
                            }
                        ]}
                        defaultSorted={[
                            {
                                id: "mail",
                                desc: false
                            }
                        ]}
                        manual
                        pageText={""}
                        ofText={""}
                        pages={this.state.pages}
                        page={this.state.page}
                        onPageChange={(pageIndex) => this.setState({
                            page: pageIndex
                        })}
                        onFetchData={this.fetchData.bind(this)}
                        showPageJump={false}
                        showPageSizeOptions={false}
                        defaultPageSize={10}
                        className="-striped -highlight"
                        collapseOnDataChange={false}
                    />
                </div>
            </div>
        );
    }
}

export default ListAdminsTab;